import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Pagination, Typography } from '@mui/material';

interface Props {
  total: number;
  page: number;
  limit: number;
  loading: boolean;
}

export default function ArtworkPagination({ total, page, limit, loading }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();

  const pageCount = Math.max(1, Math.ceil(total / limit));

  const handleChange = (_: React.ChangeEvent<unknown>, newPage: number) => {
    setSearchParams({ page: String(newPage), q: searchParams.get('q') ?? '' });
  };

  const rangeLabel = (): string => {
    if (total === 0) return 'No artworks found';
    const start = (page - 1) * limit + 1;
    const end = Math.min(page * limit, total);
    return `Showing ${start}–${end} of ${total} artworks`;
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={1} mt={2}>
      <Typography variant="body2" color="text.secondary">
        {rangeLabel()}
      </Typography>
      <Pagination
        count={pageCount}
        page={page}
        onChange={handleChange}
        disabled={loading}
        siblingCount={1}
        boundaryCount={1}
        color="primary"
      />
    </Box>
  );
}
